import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { checkStoreState, setInitialStoreState } from '../../../../../../common';
import { HubItemFacade } from '../hub-item.facade';
import { HubTrucksFacade } from './hub-trucks.facade';

@Injectable({
  providedIn: 'root',
})
export class HubTrucksGuard {
  constructor(private hubItemFacade: HubItemFacade, private hubTrucksFacade: HubTrucksFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.hubItemFacade.hubId$.pipe(switchMap((hubId: number) => checkStoreState(this.hubTrucksFacade, hubId)));
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.hubTrucksFacade);
  }
}
